module.exports = __webpack_public_path__ + "img/9类杂项.e499f8cc.webp";